import React, { useState, useEffect } from "react";
import { Table } from "reactstrap";
import { LoadingMessage } from "../../Controls";
import { DateField } from "../../../../utils";
import { addMonth } from "./../../../Modal/ActivityV2/helper";
import { FormattedDate } from "react-intl";
import style from "./styles.module.scss";

const Agencies = ({ assetId, services, wizzToggle, wizzOnChange }) => {
  const [agencies, setAgencies] = useState(false);
  const [active, setActive] = useState(false);
  const [filter, setFilter] = useState({
    FromDate: addMonth(new Date(), -31).toString(),
    ToDate: new Date().toString(),
  });

  useEffect(() => {
    setAgencies(false);
    setActive(false);
    services.creditsRatings({ assetId, filter }).then(({ result, creditsRatings }) => {
      setAgencies(creditsRatings);
    });
  }, [filter]);

  return (
    <div>
      <div className={style.filter}>
        <div className={style.field}>
          <div className={style.label}>From Date</div>
          <div className={style.formDate}>
            <DateField
              disabled={false}
              label=""
              name="FromDate"
              onChange={(name, value) => setFilter({ ...filter, FromDate: value })}
              value={filter.FromDate || new Date().toLocaleDateString("en")}
            />
          </div>
        </div>
        <div className={style.field}>
          <div className={style.label}>To Date</div>
          <div className={style.formDate}>
            <DateField
              disabled={false}
              label=""
              name="ToDate"
              onChange={(name, value) => setFilter({ ...filter, ToDate: value })}
              value={filter.ToDate || new Date().toLocaleDateString("en")}
            />
          </div>
        </div>
      </div>
      <Table className={style.agencies} hover>
        <thead>
          <tr>
            <th></th>
            <th>Date</th>
            <th>Agency detail</th>
          </tr>
        </thead>
        <tbody>
          {agencies ? (
            <React.Fragment>
              {agencies.map((date) => (
                <React.Fragment>
                  {date.Agencies.map((ag, index) => (
                    <React.Fragment>
                      <tr
                        className="cursor-pointer"
                        key={`ag-${ag.CreditRatingAgencyId}-${ag.CreditRatingAgencyDate}`}
                        onClick={() => setActive(active === getRowKey(ag, index) || getRowKey(ag, index))}
                      >
                        <td>
                          <span>
                            {active === getRowKey(ag, index) ? (
                              <i className="icon-arrow-down icons font-1lg mt-1 d-block"></i>
                            ) : (
                              <i className="icon-arrow-right icons font-1lg mt-1 d-block"></i>
                            )}
                          </span>
                        </td>
                        <td>
                          <FormattedDate value={ag.CreditRatingAgencyDate} />
                        </td>
                        <td>{ag.CreditRatingAgencyName}</td>
                      </tr>
                      {active === getRowKey(ag, index) && (
                        <tr>
                          <td colSpan="3" className="p-0">
                            <Scores scores={ag.Scores} />
                          </td>
                        </tr>
                      )}
                    </React.Fragment>
                  ))}
                </React.Fragment>
              ))}
              {agencies.length == 0 && <EmptyOrLoading />}
            </React.Fragment>
          ) : (
            <EmptyOrLoading loading />
          )}
        </tbody>
      </Table>
    </div>
  );
};

const Scores = ({ scores }) => (
  <div className={style.scores}>
    <Table>
      <thead>
        <th>Score</th>
        <th>Score value</th>
      </thead>
      <tbody>
        {scores.map((score) => (
          <tr key={`score-${score.CreditRatingAgencyScore}`}>
            <td>{score.CreditRatingAgencyScore}</td>
            <td>{score.CreditRatingAgencyScoreValue}</td>
          </tr>
        ))}
      </tbody>
    </Table>
  </div>
);

function getRowKey(agency, index) {
  return `${agency.CreditRatingAgencyId}-${agency.CreditRatingAgencyDate}-${index}`;
}

const EmptyOrLoading = ({ loading }) => (
  <tr>
    <td colSpan="7" className="bg-white">
      {loading ? (
        <LoadingMessage text="Loading agencies credits ratings" />
      ) : (
        <span className="text-center d-block h5 m-3 mt-4">No asset agencies data</span>
      )}
    </td>
  </tr>
);

export default Agencies;
